// extracted by mini-css-extract-plugin
export default {"menuBlock":"NF-z","title":"OF-z","nav":"PF-z","flexCell":"QF-z","facetLink":"RF-z"};